import { useEffect, useState, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import classes from "./CustomInput.module.css";
import ResetSearchIcon from "../assets/reset_search_icon.png";
import Loader, { LOADER_SIZES } from "./Loader";

const CustomInputWithUnit = forwardRef(
  (
    {
      title,
      type = "text",
      textAlign,
      thick,
      flex,
      errorText,
      onChange,
      resetSearch,
      readonly,
      loading = null,
      unit,
      disabled,
      ...props
    },
    ref,
  ) => {
    const { t } = useTranslation("general");
    const [isWritting, setIsWritting] = useState(
      () =>
        props.value !== null && props.value !== undefined && props.value !== "",
    );

    const [displayValue, setDisplayValue] = useState(() => {
      if (
        type === "moneyV2" &&
        props.value !== null &&
        props.value !== undefined
      ) {
        return props.value.toString();
      }
      return props.value ?? "";
    });

    // Update isWritting state when value changes
    // useEffect(() => {
    //   setIsWritting(
    //     props.value !== null && props.value !== undefined && props.value !== ""
    //   );

    //   if (type === "moneyV2") {
    //     const currentCleanValue = displayValue.replace(/,/g, "");
    //     const propsValue =
    //       props.value !== null && props.value !== undefined
    //         ? props.value.toString()
    //         : "";

    //     if (currentCleanValue !== propsValue) {
    //       setDisplayValue(propsValue);
    //     }
    //   }
    // }, [props.value, type, displayValue]);

    useEffect(() => {
      setIsWritting(
        props.value !== null && props.value !== undefined && props.value !== "",
      );

      if (type === "moneyV2") {
        const currentCleanValue = displayValue.replace(/,/g, "");
        const propsValue =
          props.value !== null && props.value !== undefined
            ? props.value.toString()
            : "";

        // Only update if the numeric values are different
        // This prevents overwriting user's trailing zeros/decimal point
        if (
          parseFloat(currentCleanValue) !== parseFloat(propsValue) &&
          !(currentCleanValue === "" && propsValue === "")
        ) {
          setDisplayValue(propsValue);
        }
      }
    }, [props.value, type]);

    const handleChange = (e) => {
      let { value } = e.target;

      if (type === "money") {
        // Allow only numbers, commas, and spaces
        const regex = /^[\d,. ]*$/;

        if (!regex.test(value)) {
          return;
        }
      }

      if (type === "moneyV2") {
        // Allow only digits, commas, and one decimal point
        const regex = /^[\d,.]*$/;
        if (!regex.test(value)) {
          return;
        }

        // Ensure only one decimal point is allowed
        const dotCount = (value.match(/\./g) || []).length;
        if (dotCount > 1) {
          return;
        }

        // Update display value to show what user typed
        setDisplayValue(value);

        // Clean the value by removing commas and convert to float for parent component
        if (onChange) {
          const cleanValue = value.replace(/,/g, "");

          // Handle empty value
          if (cleanValue === "") {
            const syntheticEvent = {
              target: {
                name: e.target.name,
                value: "",
              },
            };
            onChange(syntheticEvent);
            return;
          }

          let valueToSend;
          if (cleanValue.endsWith(".")) {
            valueToSend = cleanValue; // Send "100." as string
          } else {
            const floatValue = parseFloat(cleanValue);
            valueToSend = isNaN(floatValue) ? "" : floatValue;
          }

          const syntheticEvent = {
            target: {
              name: e.target.name,
              value: valueToSend,
            },
          };
          onChange(syntheticEvent);
        }
      } else {
        if (onChange) {
          onChange(e);
        }
      }

      setIsWritting(e.target.value.length > 0);
    };

    // function to set the data back to all
    // when the cancel button is clicked
    const handleClear = () => {
      if (onChange) {
        onChange({ target: { value: "" } });
      }

      setIsWritting(false);

      // Clear display value for moneyV2
      if (type === "moneyV2") {
        setDisplayValue("");
      }

      if (resetSearch) {
        resetSearch();
      }
    };

    const showError = errorText;

    return (
      <div className={flex ? classes.inputContainer : ""}>
        {title && <label className={classes.label}>{title}</label>}
        {showError && <div className="error-message">{t(errorText)}</div>}
        {type === "textarea" ? (
          <textarea
            className={`${classes.textInput} ${thick ? classes.thick : ""} ${
              disabled ? classes.disabled : ""
            }`}
            {...props}
            onChange={onChange || handleChange}
            ref={ref}
            disabled={disabled}
          />
        ) : (
          <div className="o-row o-row--gap-size_300 u-width_full-width">
            <div className={classes.inputWrapper}>
              <input
                className={`${classes.textInput} ${
                  thick ? classes.thick : ""
                } ${disabled ? classes.disabled : ""}`}
                {...props}
                value={type === "moneyV2" ? displayValue : (props.value ?? "")}
                type={type === "moneyV2" ? "text" : type}
                onChange={handleChange}
                readOnly={readonly}
                ref={ref}
                disabled={disabled}
              />
              {loading === true && (
                <div className={classes.loaderHolder}>
                  <Loader size={LOADER_SIZES.XSMALL} withoutText />
                </div>
              )}
              {isWritting && resetSearch && !readonly && (
                <button className={classes.clearButton} onClick={handleClear}>
                  <img src={ResetSearchIcon} />
                </button>
              )}
            </div>
            <div className="o-row o-row--horizontal-align_center o-row--vertical-align_center u-min-width-specific_28">
              {unit}
            </div>
          </div>
        )}
      </div>
    );
  },
);

export default CustomInputWithUnit;
